let isAnnouncementBarInitialized = false;

function announcebar() {
  if (isAnnouncementBarInitialized) return;
  isAnnouncementBarInitialized = true;

  var defaults = {
    sections: "li",
    duration: 3000,
    loop: true,
    currentClass: "current",
    direction: "up"
  };

  function scrollText(container, options) {
    // Block function if body has static_usps class
    if (document.body.classList.contains('template-product.static_usps') && 
        container.closest('.prod-add-usps')) return;
    
    var opts = Object.assign({}, defaults, options || {});
    var sections = container.querySelectorAll(opts.sections);
    if (!sections.length) return;
    var arrElements = Array.from(sections);
    var ulElement = container.querySelector("ul");
    if (!ulElement) return;
    ulElement.classList.add("ulzone");
    var content = ulElement;
    var temp = content.children[0].offsetHeight;
    var duration = opts.duration;
    var intervalID;

    // For seamless infinite scroll, create enough duplicates
    var originalCount = sections.length;
    
    // Only clone items if there's more than 1 for seamless loop
    if (originalCount > 1) {
      var originalItems = Array.from(sections);
      originalItems.forEach(item => {
        var clone = item.cloneNode(true);
        content.appendChild(clone);
      });
    }
    
    var currentIndex = 0;

    function up() {
      // Check if we need to reset before moving
      if (currentIndex >= originalCount) {
        // Reset instantly to the beginning
        content.style.transition = "none";
        content.style.marginTop = "0px";
        currentIndex = 0;
        // Force reflow
        content.offsetHeight;
        // Small delay to ensure reset is processed
        setTimeout(() => {
          content.style.transition = "margin-top 1s ease-in-out";
        }, 10);
      }
      
      currentIndex++;
      content.style.transition = "margin-top 1s ease-in-out";
      content.style.marginTop = `-${currentIndex * temp}px`;
    }

    function initLayout() {
      handleStyle();
      startScroll();
    }

    function handleStyle() {
      // Initialize any needed styles
      content.style.marginTop = "0px";
    }

    function startScroll() {
      if (intervalID) {
        clearInterval(intervalID);
      }
      // Only animate if there's more than 1 original item
      if (originalCount > 1) {
        intervalID = setInterval(up, duration);
      }
    }

    function handleVisibilityChange() {
      if (document.hidden) {
        clearInterval(intervalID);
      } else {
        startScroll();
      }
    }

    function setupVisibilityChangeHandling() {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    setupVisibilityChangeHandling();
    initLayout();
  }


  document.querySelectorAll(".announce-inr").forEach(container => {
    // Only apply JS animation for vertical scroll
    const section = container.closest('.section-announcement-bar');
    if (!section || !section.classList.contains('horizontal')) {
      scrollText(container, { duration: 3000, loop: true });
    }
  });

  document.querySelectorAll(".product-usps").forEach(el => {
    scrollText(el, { duration: 3000, loop: true });
  });

  function initUspsIn(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(".product-usps")) {
      scrollText(node, { duration: 3000, loop: true });
    } else {
      node.querySelectorAll(".product-usps").forEach(el => {
        scrollText(el, { duration: 3000, loop: true });
      });
    }
  }

  const cartSidebar = document.querySelector(".cart-sidebar");
  if (cartSidebar) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(initUspsIn);
      });
    });
    observer.observe(cartSidebar, { childList: true, subtree: true });
  }

}

announcebar();
// function announcebar(options){
//   var defaults = {
//     // container: '.announce-inr',
//     container: options.container,
//     sections: 'li',
//     // duration: 5000,
//     duration: options.duration,
//     loop: true,
//     currentClass: 'current',
//     direction: 'up'
//   };
//   function scrollText(opts, container){
//     if (!container) return;
//     var sections = container.querySelectorAll(opts.sections);
//     if (sections.length <= 1) return;
//     var arrElements = Array.from(sections);
//     var ul = container.querySelector('ul');
//     ul.classList.add('ulzone');
//     var content = container.querySelector('.ulzone');
//     var contentHeight = content.offsetHeight;
//     var contentChildHeight = content.children[0].scrollHeight;
//     var temp = contentChildHeight;
//     var currentClass = opts.currentClass;
//     var iIndex = 0;
//     var intervalID;
//     var firstChildClone = content.children[0].cloneNode(true);
//     content.appendChild(firstChildClone);
//     initLayout();
//     handleStyle();

//     function up(){
//       content.style.transition = 'margin-top 1s';
//       content.style.marginTop = '-' + contentChildHeight + 'px';
//       arrElements.forEach(function (el) {
//         el.classList.remove(currentClass);
//       });
//       iIndex += 1;
//       if(iIndex >= arrElements.length){
//         iIndex = 0;
//       }
//       arrElements[iIndex].classList.add(currentClass);

//       if(contentChildHeight >= contentHeight){
//         setTimeout(function(){
//           content.style.transition = 'none';
//           content.style.marginTop = '0';
//           contentChildHeight = temp;
//         }, 1000);
//       }else{
//         contentChildHeight += temp;
//       }
//     }
    
//     function initLayout(){
//       var clone = content.cloneNode(true);
//       content.parentNode.appendChild(clone);
//     }
//     function handleStyle(){
//       arrElements[iIndex].classList.add(currentClass);
//     }
//     function scroll(){
//       if(intervalID){
//         clearInterval(intervalID);
//       }
//       intervalID = setInterval(up, opts.duration);
//     }
//     function handleVisibilityChange(){
//       if(document.hidden){
//         clearInterval(intervalID);
//       }else{
//         scroll();
//       }
//     }
//     if(typeof document.hidden !== "undefined"){
//       document.addEventListener("visibilitychange", handleVisibilityChange, false);
//     }
//     scroll();
//   }
//   var mergedOptions = Object.assign({}, defaults, options || {});
//   var containers = document.querySelectorAll(mergedOptions.container);
//   containers.forEach(function (container) {
//     scrollText(mergedOptions, container);
//   });
// }
// document.addEventListener('DOMContentLoaded', function(){
//   announcebar({
//     container: '.announce-inr',
//     duration: 3000
//   });
//   announcebar({
//     container: '.product-usps',
//     duration: 3000
//   });
// });
// if(document.querySelector('.close-announce')) document.querySelector('.close-announce').addEventListener('click',function(e){
//   e.preventDefault();
//   document.querySelector('.section-announcement-bar').classList.add('hide-announce');
// });